import { useEffect } from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch } from "react-redux";
import { getAdminMapDetails } from "../slice/adminMapSlice";

const useMapData = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();

  const getMapData = async (param) => {
    try {
      const response = await Axios.post("get_map_data", param);
      const data = response.data;
      dispatch(getAdminMapDetails(data));
      return data;  
    } catch (error) {
      console.error("Error fetching admin map data:", error);
      throw error;  
    }
  };

  return getMapData;
};

export default useMapData;